// Galgotias University Json

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;
const universityBgImage =
  imageBaseUrl + "International-Relation/University/Galgotias-University.jpg";

const greater_noida =
  imageBaseUrl + "International-Relation/University/Noida.png";

const Fees_Galgotias_Africa =
  imageBaseUrl +
  "International-Relation/University/fee-structure/Fees_Galgotias_Africa.pdf";
const Fees_Galgotias_Middle_East =
  imageBaseUrl +
  "International-Relation/University/fee-structure/Fees_Galgotias_Middle East.pdf";
const Fees_Galgotias_SAARC =
  imageBaseUrl +
  "International-Relation/University/fee-structure/Fees_Galgotias_SAARC.pdf";

const k1 = imageBaseUrl + "universityKnow/k1.png";
const k2 = imageBaseUrl + "universityKnow/k2.png";
const k3 = imageBaseUrl + "universityKnow/k3.png";
const k5 = imageBaseUrl + "universityKnow/k5.png";
const k6 = imageBaseUrl + "universityKnow/k6.png";

export const galgotiasUniversityJson = {
  BannerData: {
    heading: "Galgotias University",
    backgroundImage: universityBgImage,
    content: (
      <>
        Galgotias University, established in 2011 in Greater Noida, Uttar
        Pradesh, is a leading private university known for its academic
        excellence and industry-oriented programs. Recognized by UGC, AICTE, and
        accredited by NAAC, the university offers over 200 undergraduate,
        postgraduate, and doctoral programs across disciplines like engineering,
        management, law, and healthcare. With modern infrastructure, global
        collaborations, and a strong placement record, Galgotias attracts top
        recruiters like Infosys, Wipro, and TCS. The university emphasizes
        research, innovation, and skill development, providing students with
        hands-on learning and industry exposure. Its vibrant campus fosters
        holistic development through extracurricular activities, clubs, and
        cultural events.
      </>
    ),
  },

  // University Details
  universityDetails: [
    {
      id: 1,
      title: "Name",
      subtitle: "Galgotias University",
      image: imageBaseUrl + "universityinfo/1.png",
    },
    {
      id: 2,
      title: "Location",
      subtitle: " Greater Noida, Uttar Pradesh, India",
      image: imageBaseUrl + "universityinfo/2.png",
    },
    {
      id: 3,
      title: "Founded",
      subtitle: "2011",
      image: imageBaseUrl + "universityinfo/3.png",
    },
    {
      id: 4,
      title: "Type",
      subtitle: "Private University",
      image: imageBaseUrl + "universityinfo/4.png",
    },
    {
      id: 5,
      title: "Total Enrollment",
      subtitle: "Over 40,000 students",
      image: imageBaseUrl + "universityinfo/5.png",
    },
    {
      id: 6,
      title: "International Students",
      subtitle: " Approximately 3% of total enrollment",
      image: imageBaseUrl + "universityinfo/6.png",
    },
    {
      id: 7,
      title: "Website",
      subtitle: "Strengthening international recognition and credibility",
      image: imageBaseUrl + "universityinfo/7.png",
      url: "https://www.galgotiasuniversity.edu.in/",
    },
  ],

  WhyChooseThisUniversityPage: [
    {
      id: 1,
      rank: "101-150",
      title: (
        <>
          <b>NIRF Rankings 2024</b>: Overall University <b>Rank 101-150</b>{" "}
        </>
      ),
    },
    {
      id: 2,
      rank: "NAAC A+",
      title: (
        <>
          <b>NAAC A+ Accreditation</b> for academic excellence
        </>
      ),
    },
    {
      id: 3,
      rank: "NIRF #98",
      title: (
        <>
          <b> NIRF Rankings 2024</b>: Management <b>#98 Pan India </b>{" "}
        </>
      ),
    },
  ],

  feeStructure: [
    { label: "Africa", value: "Africa", pdfFile: Fees_Galgotias_Africa },
    {
      label: "Middle East",
      value: "Middle East",
      pdfFile: Fees_Galgotias_Middle_East,
    },
    { label: "SAARC", value: "Middle East", pdfFile: Fees_Galgotias_SAARC },
  ],

  KnowMore: [
    {
      title: "Campus Life",
      img: k1,
      url: "https://www.galgotiasuniversity.edu.in/p/campus-life/about-the-campus",
    },
    {
      title: "How to Apply",
      img: k2,
      url: "https://www.galgotiasuniversity.edu.in/p/international-admissions",
    },
    {
      title: "International Students",
      img: k3,
      url: " https://www.galgotiasuniversity.edu.in/p/the-international-office-at-gu",
    },

    {
      title: "Accommodation",
      img: k5,
      url: "https://www.galgotiasuniversity.edu.in/p/academics/hostel",
    },
    {
      title: "Brochure",
      img: k6,
      url: "https://www.galgotiasuniversity.edu.in/p/admission/download-brochure",
    },
  ],

  Location: {
    header: "GREATER NOIDA",
    image: greater_noida,
    content: (
      <>
        Greater Noida is rapidly emerging as a prime destination for
        international students, offering a perfect blend of quality education,
        career opportunities, and an excellent standard of living.
        <br></br>
        <br></br>
        <ul style={{ "margin-left": "20px" }}>
          <li>
            <b>Top Universities</b>
          </li>
          <li>
            <b>Career Hub</b>
          </li>
          <li>
            <b>Vibrant Lifestyle</b>
          </li>
          <li>
            <b>Great Connectivity</b>
          </li>
          <li>
            <b>Safe & Multicultural</b>
          </li>
        </ul>
      </>
    ),
  },
};
